module.exports = __webpack_public_path__ + "static/media/bulb.16d12e9f.png";